import React from 'react'
import { Iframe } from '../../components/iframe'

const IframeModal = ({ url, title, width, height }) => {
  return <Iframe src={url} title={title} width={width} height={height} />
}

export default IframeModal

